import { render, staticRenderFns } from "./LeadStatus.vue?vue&type=template&id=629df222&"
import script from "./LeadStatus.vue?vue&type=script&lang=js&"
export * from "./LeadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports